import React from 'react'

interface PageToolbarProps {
  // Left-hand content (e.g. the infra status rows on the Status Dashboard)
  children?: React.ReactNode
  error?: string | null
  lastSync: string | null
  onSync: () => void
  syncing: boolean
  disabled?: boolean
  syncLabel: string
}

// The "Last synced ... [sync]" bar at the top of every page
const PageToolbar: React.FC<PageToolbarProps> = ({
  children,
  error,
  lastSync,
  onSync,
  syncing,
  disabled,
  syncLabel,
}) => (
  <div className="report-header page-toolbar">
    <div className="page-toolbar__left">{children}</div>
    <div className="page-toolbar__actions">
      {error && <p className="page-toolbar__error">{error}</p>}
      {lastSync && <small className="text-muted">Last synced: {new Date(lastSync).toLocaleString()}</small>}
      <button
        className={`sync-btn${syncing ? ' syncing' : ''}`}
        onClick={onSync}
        disabled={syncing || disabled}
        title={syncing ? 'Syncing...' : syncLabel}
        aria-label={syncing ? 'Syncing...' : syncLabel}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="23 4 23 10 17 10" />
          <polyline points="1 20 1 14 7 14" />
          <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
      </button>
    </div>
  </div>
)

export default PageToolbar
